<template>
  <section v-if="episodes">
    <div class="episodes container">
      <episode-module v-for="episode in episodes" :key="episode.slug" :episode="episode" />
    </div>
    <div class="container text-right"><router-link :to="{name: 'Episodes'}" class="button button-underline">All Episodes</router-link></div>
  </section>
</template>

<script>
import EpisodeModule from '@/components/common/EpisodeModule'

export default {
  name: 'latest-episodes',
  props: ['episodes'],
  components: {
    EpisodeModule
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import ../../assets/styles/colors
@import ../../assets/styles/mixins

$sectionColor: $turquoise

.button-underline
  border-color: $sectionColor

section
  margin-bottom: 52px
  +tablet
    margin-top: 64px
  .episodes
    +tablet
      display: flex
      justify-content: space-between
</style>



// WEBPACK FOOTER //
// LatestEpisodes.vue?edd3e7e4